import { Requirement } from "@siteimprove/alfa-act";
/**
 * @public
 */
export class ARIA extends Requirement {
    static of(uri) {
        return new ARIA(uri);
    }
    constructor(uri) {
        super("ARIA", uri);
    }
    toJSON() {
        return super.toJSON();
    }
}
/**
 * @public
 */
(function (ARIA) {
    function isARIA(value) {
        return value instanceof ARIA;
    }
    ARIA.isARIA = isARIA;
})(ARIA || (ARIA = {}));
//# sourceMappingURL=aria.js.map